import React, { useEffect } from "react";
import {
  Container,
  FormHelperText,
  Grid,
  Stack,
  Select,
  MenuItem,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getAllBuildings,
  getAvaibleBedsByBuildingId,
  getBedInfosRegular,
  finishBedChangeForRegular,
  finishBedChangeForDailyandMonthly,
  getBedInfoDailyorMonthly,
} from "../../../../redux/actions/RatActions";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useDispatch, useSelector } from "react-redux";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
const useStyles = makeStyles({
  root: {
    height: 40,
    width: 50,
  },
  size: {
    width: 40,
    height: 30,
  },
  gap: {
    paddingLeft: 20,
    height: 100,
  },
});
const notify = () => toast();
const ChangeBed = (props) => {
 
  const [disableButtons, setDisableButtons] = React.useState(false);
  const [error, setError] = React.useState("");
  const [error1, setError1] = React.useState("");

  const [open, setOpen] = React.useState(false);
  const [buildingId, setBuildingId] = React.useState(0);
  const changeBedStatus = useSelector(
    (state) => state.buildings.changeBedStatus
  );
  const handleClose = () => {
    setOpen(false);
  };
  const getBeds = (e) => {
    if (e.target.value === "" || e.target.value === undefined || e.target.value === null) {
      setError("please select Building");
    } else {
      setBuildingId(e.target.value);
      setError("")
      dispatch(getAvaibleBedsByBuildingId(e.target.value));
    }
  };
  const getBedInfo = (e) => {
    if (e.target.value === "" || e.target.value === undefined || e.target.value === null){
      setError1("Please select Bed")

    }else{
      setError1("")
      {
        props.guestdetails.occupancyType === "Regular"
          ? dispatch(
              getBedInfosRegular(
                props.guestdetails.id,
                buildingId,
                e.target.value
              )
            )
          : dispatch(
              getBedInfoDailyorMonthly(
                props.guestdetails.id,
                buildingId,
                e.target.value
              )
            );
      }

    }
   
  };
  const handleChangeBed = () => {
    console.log(bedInfo)
    if(bedInfo === null && error ===""){
      setError1("Please select Bed")
    }
    else if(bedInfo === null && error !=="") {
      setError1("Please select Building")
    }
    else{
      setError1("")
      {
        props.guestdetails.occupancyType === "Regular"
          ? dispatch(finishBedChangeForRegular(bedInfo))
          : dispatch(finishBedChangeForDailyandMonthly(bedInfo));
      }
      setDisableButtons(true);
      if (changeBedStatus) {
        toast.success("Bed Change SuccessFully");
      }
      props.editGuestHandler();
      props.handleCloseGuestModalWindow();
      
    }
    
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllBuildings());
  }, []);
  const buildings = useSelector((state) => state.buildings.allBuildings);
  const availableBeds = useSelector((state) => state.buildings.availableBeds);
  const bedInfo = useSelector((state) => state.buildings.bedInfo);
  const classes = useStyles();

  return (
    <Grid container>
      <Grid item xs={12}>
        <Container maxWidth="md">
          <div>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <h5>Select Building *</h5>

                <Select
                  IconComponent={() => (
                    <ArrowDropDownIcon className={classes.size} />
                  )}
                  onChange={getBeds}
                  onBlur={getBeds}
                >
                  {buildings.map((item) => (
                    <MenuItem value={item.buildingId}>
                      {item.buildingName}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText style={{ color: "red" }}>
                  {error}
                </FormHelperText>
              </Grid>
              <Grid item xs={6}>
                <h5>Select Bed *</h5>
                <Select
                  IconComponent={() => (
                    <ArrowDropDownIcon className={classes.size} />
                  )}
                  onChange={getBedInfo}
                  onBlur={getBedInfo}
                >
                  {availableBeds.map((item) => (
                    <MenuItem value={item.bedId}>{item.bedId}</MenuItem>
                  ))}
                </Select>
                <FormHelperText style={{ color: "red" }}>
                  {error1}
                </FormHelperText>
              </Grid>
              {bedInfo === undefined || bedInfo === null? (
                <></>
              ) : (
                <>
                  <p
                    style={{
                      fontStyle: "normal",
                      fontWeight: "bolder",
                      margin: "5px",
                    }}
                  >
                    This is the info of Bed your are trying to Move{" "}
                  </p>
                  <MDBox style={{ border: 3, borderColor: "red" }}>
                    <Stack
                      spacing={2}
                      style={{ float: "right", margin: "10px", border: "5px" }}
                    >
                      <h5>BuildingName :{bedInfo.buildingName}</h5>
                      <h5>BedId:{bedInfo.bedId}</h5>
                      <h5>Sharing:{bedInfo.sharing}</h5>
                      <h5>Room Type:{bedInfo.roomType}</h5>
                      <h5>Due Amount:{bedInfo.dueAmount.toFixed(0)}</h5>
                      <h5>Default Rent:{bedInfo.defaultRent.toFixed(0)}</h5>
                    </Stack>
                  </MDBox>
                </>
              )}
              <Grid item xs={6} sx={{ marginTop: 2 }}>
                <MDButton
                  width="20%"
                  variant="contained"
                  color="info"
                  size="medium"
                  justify="center"
                  component="label"
                  onClick={handleChangeBed}
                >
                  Submit
                </MDButton>
              </Grid>
            </Grid>
            <ToastContainer
              maxWidth="sx"
              position="top-right"
              autoClose={3000}
              type="toast.TYPE.SUCCESS"
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </div>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </Container>
      </Grid>
    </Grid>
  );
};

export default ChangeBed;
